<template>
  <proa-modal
    :modal="modal"
    :title="$t('models.taskCard.attributes.taskListId')"
    @close="$emit('close')"
  >
    <proa-select
      v-model="innerTaskListId"
      :options="taskListOptions"
    />
    <template slot="footer">
      <proa-button
        @click.native="$emit('close')"
        class="default-button-width mr-2"
      >
        {{ $t('common.cancel') }}
      </proa-button>
      <proa-button
        @click.native="$emit('onUpdateTaskListId', innerTaskListId)"
        class="default-button-width"
      >
        {{ $t('common.ok') }}
      </proa-button>
    </template>
  </proa-modal>
</template>

<script>
export default {
  name: 'EditProjectTaskCardTaskListIdModal',
  props: {
    taskListId: [String, Number],
    taskLists: Array,
    modal: Boolean
  },
  computed: {
    taskListOptions: function() {
      return this.taskLists.map((taskList) => {
        const currentTaskList = taskList.id == this.taskListId
        return {
          label: taskList.title,
          value: taskList.id,
          selected: currentTaskList,
          disabled: currentTaskList
        }
      })
    },
  },
  data() {
    return {
      innerTaskListId: null
    }
  },
  methods: {
    initTaskListId: function() {
      this.innerTaskListId = this.taskListId
    }
  },
  watch: {
    modal: function(value) {
      if (!value) return
      this.initTaskListId()
    }
  }
}
</script>
